
export enum EnrollmentFieldCodeName {
    ACCHOLDERNAME = "Name on Account",
    ACCOUNTNB = "Account Number",
    ACCOUNTTYPE = "Account Type",
    AGENTEMAIL = "AGENTEMAIL",
    AGENTFN = "AGENTFN",
    AGENTID = "Agent ID",
    AGENTLN = "AGENTLN",
    APPADD1 = "Permanent Address 1",
    APPADD2 = "Permanent Address 2",
    APPCITY = "Permanent City",
    APPDOB = "Date of Birth",
    APPDT = "Application Date",
    APPEMAIL = "Email",
    APPFN = "First Name",
    APPGEN = "Sex",
    APPLN = "Last Name",
    APPMI = "Middle Initial",
    APPST = "Applicant State",
    PERST = "Permanent State",
    APPZIP = "Permanent Zip",
    POVERIND = "PO Box Override",
    ATESTPROOF = "ATESTPROOF",
    AUTHREPADD1 = "Authorized Representative Address1",
    AUTHREPADD2 = "Authorized Representative Address2",
    AUTHREPCITY = "Authorized Representative City",
    AUTHREPIND = "AUTHREPIND",
    AUTHREPNAME = "Authorized Representative Name",
    AUTHREPPHONE = "Authorized Representative Phone",
    AUTHREPREL = "Authorized Representative Relationship",
    AUTHREPST = "Authorized Representative State",
    AUTHREPZIP = "Authorized Representative Zip",
    APPPHONE = "Phone Number",
    CELLPHONE = "Cell Phone",
    COBBIN = "COBBIN",
    COBEFFDT = "COBEFFDT",
    COBPCN = "COBPCN",
    COBTERMDT = "COBTERMDT",
    COMPLETEIND = "COMPLETEIND",
    CONF = "Confirmation Number",
    CONTRACT = "CONTRACT",
    CUID = "CUID",
    CULTURE = "CULTURE",
    EFFDT = "Effective Date",
    EFTTYPE = "EFTTYPE",
    ELECTION = "Election Period",
    FININSTNAME = "Financial Institution",
    HICN = "Medicare Number",
    LANG = "Language Preference",
    LEGREPEMAIL = "LEGREPEMAIL",
    LTCFACILITY = "Long-term Care Name",
    LTCPHONE = "Long-term Care Phone",
    MAILADD1 = "Mailing Address 1",
    MAILADD2 = "Mailing Address 2",
    MAILCITY = "Mailing City",
    MAILST = "Mailing State",
    MAILZIP = "Mailing Zip",
    MEDA = "Medicare Part A Date",
    MEDB = "Medicare Part B Date",
    NOTES = "Notes",
    OTHCVRG = "OTHCVRG",
    OTHCVRGGRP = "OTHCVRGGRP",
    OTHCVRGID = "Other Coverage ID",
    OTHCVRGNAME = "Secondary Coverage Name",
    PLANNAME = "Selected Plan",
    PLANST = "PLANST",
    PLANTYPE = "PLANTYPE",
    PLANYEAR = "PLANYEAR",
    POA = "POA",
    PWO = "PWO",
    ROUTINGNB = "Routing Number",
    SEPEFFDT = "SEP Date",
    SEPREASONCD = "Enrollment Criteria",
    SOA = "SOA",
    SUFFIX = "SUFFIX",
    TITLE = "Title",
    DEX = "DEX",
    AGENTDEX = "Enrollment Type",
    APPSIGNEDIND = "APPSIGNEDIND",
    AUTHREPSIGNEDIND = "AUTHREPSIGNEDIND",
    SUBMISSIONTYPECODE = "SUBMISSIONTYPECODE",
    DATAENTRYID = "Data Entry ID",
    PREMIUMPAYTYPE = "Premium Payment Type",

    EOB = "Receives Electronic Explanation of Benefits",
    PaplerlessEOB = "Receives Electronic Explanation of Benefits",
    Accessible = "Accessible Communications Format",
    ENROLLEEWORKSTATUS = 'Enrollee Work Status',
    SPOUSEWORKSTATUS = 'Spouse Work Status',
    CAREQUALIFIER = "Care Qualifier",
    EXTERNALMEMBERID = "External Member ID",
    CAREFACILITY = "Care Facility",
    OTHERCOVNAME = "Other Coverage Name",
    OTHERCOVID = "Other Coverage ID",
    OTHERCOVGRP = "Other Coverage Group",
    OTHERCOVRXBIN = "Other Coverage RxBIN",
    OTHERCOVRXPCN = "Other Coverage RxPCN",
    OTHERCOVEF = "Other Coverage Effective Date",
    OTHERCOVTR = "Other Coverage Termination Date",
    STCOBGROUPNAME = "Group Name",
    PCARRIER = "Primary Carrier",
    PACCOUNT = "Primary Account",
    PGROUP = "Primary Group",
    SCARRIER = "Secondary Carrier",
    SACCOUNT = "Secondary Account",
    SGROUP = "Secondary Group",
    SECMBRID = "Secondary Member ID",
    RELCD = "Relationship Code",
    FAMILYID = "Family ID",
    PERSONCD = "Person Code",
    LTCADD1 = "Address of Facility",
    DISENROLLIND = 'Disenrollment/Cancellation',
    DISENROLLDATE = 'Disenrollment/Cancellation Effective Date',
    DISENROLLNOTICEDT = 'Disenrollment/Cancellation Date of Notice',
    DISENROLLREASONCD = 'Disenrollment/Cancellation Reason Code',
    DISENROLLTYPE = 'Disenrollment/Cancellation Type',
    RACE = 'Race',
    ETHNICITY = 'Ethnicity',
    GENDERNPRONOUN = 'Self Identify',
    CURRENTGENDER = 'Gender Identity',
    GENDERNPRONOUNOTH = 'Different Self Identify',
    CURRENTGENDEROTH = 'Different Gender Identity',

     //Relationship to Enrollee
    INDREPNAME = "Individual Rep Name",
    RELTOENROLL = "Relationship to enrollee",
    NPN = "National Producer Number",
    INDREPIND ="Individual Rep Indicator"
}

